module.exports = __webpack_public_path__ + "res/roboto-v15-latin-100.woff2";


//////////////////
// WEBPACK FOOTER
// ./client/app/vendor/googlefonts/roboto-v15-latin-100.woff2
// module id = 96
// module chunks = 1